export default class Document {
  constructor() {
    this.id = null;
    this.documentName = null;
    this.lastModifiedOn = null;
    this.base64File = null;
    this.fileAltName = null;
  }
}
